import { render } from "./Period.vue?vue&type=template&id=4695cbd4"
import script from "./Period.vue?vue&type=script&lang=js"
export * from "./Period.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__